import { useState } from "react";
import { userStatusOptions } from "../../../../utils/dataLists";
import AdminFilterBar, { MultiSelectField } from "../../_components/AdminFilterBar";

// Same search box + collapsible filter panel as the booking list.
const Filter = ({ search, setSearch, onApplyStatus = () => {} }) => {
  const [userStatus, setUserStatus] = useState([]);

  const onClear = () => {
    setSearch("");
    setUserStatus([]);
    onApplyStatus("");
  };

  return (
    <AdminFilterBar
      search={search}
      setSearch={setSearch}
      searchPlaceholder="Search name / email"
      columns={4}
      onApply={() => onApplyStatus(userStatus.map((item) => item.value).join(","))}
      onClear={onClear}
    >
      <MultiSelectField label="Status" value={userStatus} onChange={setUserStatus} options={userStatusOptions} />
    </AdminFilterBar>
  );
};

export default Filter;
